import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import tmdbApi from "../../api/tmdbApi";
import AwaitingForSession from "./AwatingSession";
import DescCPCBlock from "./descCPCBlock";
import SessionPopup from "../SessionPopup";
import axios from "axios";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

const CPCBlock = ({ img, timer, table }) => {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const navigate = useNavigate()
    const [quizInfo, setQuizInfo] = useState(null);
    const [nextSession, setNextSession] = useState(false);
    const [completedResult, setCompletedResult] = useState([])
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [timeZone, setTimeZone] = useState("Asia/Kolkata")



    function isScheduleTimeCrossed() {
        const scheduleDate = quizInfo?.meetingDate; // "2025-06-21T00:00:00Z"
        const scheduleEndTime = quizInfo?.meetingEndTime; // "14:00"
        if (scheduleDate && scheduleEndTime) {
            const timeZoneTmp = timeZone || "Asia/Kolkata"; // default fallback
            const datePart = scheduleDate.split("T")[0]; // "2025-06-21"
            const fullDateTimeStr = `${datePart}T${scheduleEndTime}`; // "2025-06-21T14:00"
            const endDateTime = dayjs.tz(fullDateTimeStr, timeZoneTmp); // converts it to that zone
            const now = dayjs().tz(timeZoneTmp); // current time in same zone
            setNextSession(now.isAfter(endDateTime));
        }
    }

    const userAgent = async () => {
        try {
            const response = await axios.get("https://d4nv8o5tzs3mt.cloudfront.net/");
            const locData = response?.data;

            // Store full data if needed later
            localStorage.setItem("loc", JSON.stringify(locData));

            // Extract timezone from CloudFront headers
            const viewerTimeZone = locData?.headers?.["cloudfront-viewer-time-zone"];
            const timeZoneTmp =
                Array.isArray(viewerTimeZone) && viewerTimeZone[0]?.value
                    ? viewerTimeZone[0].value
                    : "Asia/Kolkata"; // default fallback

            setTimeZone(timeZoneTmp);
        } catch (error) {
            console.error("Error fetching timezone:", error);
            setTimeZone("Asia/Kolkata"); // fallback in case of error
        }
    };
    useEffect(() => {
        userAgent();
        getCpcInfo()
    }, []);

    useEffect(() => {
        if (quizInfo) {
            let interval;
            isScheduleTimeCrossed();
            interval = setInterval(isScheduleTimeCrossed, 1000);
            return () => clearInterval(interval);
        }
    }, [quizInfo])
    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/")
        }
    }, [quizInfo])

    const getCpcInfo = async () => {
        const response = await tmdbApi.cpcInfo("ACTIVE");
        if (response?.result === "Invalid token or Expired") {
             setShowSessionPopupup(true)
            // localStorage.clear();
            // navigate("/")
            //  setIsLoading(false)
        } else
            if (typeof response?.result !== 'string' && response?.result?.length > 0) {
                setQuizInfo(response?.result[0])
            }
    }


    useEffect(() => {
        
            winnerInfo();
        
    }, []);

    const winnerInfo = async () => {

        const response = await tmdbApi.studentCompletedQuiz();
        if (response?.result) {
            setCompletedResult(response?.result)
        }
    }

    const handleViewQuiz = (id) => navigate(`/cpc-result/${id}`);







    // console.log('----eee', error)
    return (
        <>

            {showSessionPopupup && <SessionPopup />}
            <div className="cpc-data-table">


                {quizInfo && !nextSession ?

                    <div className="containers gap-5 align-items-start session_block pt-5 pb-5">

                        {!timer && <div className="col-lg-5 col-md-12 p-0">
                            <img src={img} alt="Quiz Cover" className="cpc-img img-fluid object-fit-cover" />
                            <div className="fw-bold note mt-2 pb-5 sub-note text-start">
                                "Subscription teaser: “Unlock recordings for INR 10,000/USD 120 annually.
                                <p className="text-start">No registration fee. No strings. Just learning."</p>
                                 {/* <p className="text-start"> Note: Please note that recording of CPC only available for people who participate and submit the quiz.</p> */}
                            </div>
                        </div>}

                        <DescCPCBlock quizInfo={quizInfo} getCpcInfo={getCpcInfo} timer={timer} />

                    </div> : <AwaitingForSession />}
                {table && completedResult && completedResult?.length > 0 &&
                    <div className="container mb-5" id="cpcTable">
                        <div className="">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h4 className="card-title">Previous CPC Result</h4>
                                        {/* <button className="reset-quiz-btn ps-3 pe-3">View All</button> */}
                                    </div>
                                    <div className="quiz-table-wrapper" >
                                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                            <table className="table table-nowrap mb-0" id="quiz-table-cpc">
                                                <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th className="scno-col">S.NO</th>
                                                        <th className="name-col">CPC Title</th>
                                                        <th className="date-col">Date</th>
                                                        <th className="date-col">Score</th>
                                                        <th className="date-col">Percentile</th>
                                                        <th className="marks-col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {completedResult && completedResult.length > 0 && completedResult.map((item, i) => (
                                                        <tr key={i}>
                                                            <td className="scno-col">
                                                                <a href="javascript:void(0);" className="text-body">{i + 1}</a>
                                                            </td>
                                                            <td className="name-col">{item?.title}</td>
                                                            <td className="date-col">{item?.formattedDate}</td>
                                                            <td className="marks-col">
                                                                <div className="winner">
                                                                    {item?.winner && (
                                                                        <span className="material-symbols-outlined icon">trophy</span>
                                                                    )}
                                                                    {item?.score}
                                                                </div>
                                                            </td>
                                                            <td className="date-col">{item?.percentileRank}</td>
                                                            <td className="marks-col d-flex justify-content-end">
                                                                <div className="upcoming-icons" style={{ display: 'flex' }}>
                                                                    <a className="text-success view-button" onClick={() => handleViewQuiz(item?.cpcid)}>
                                                                        <i className="mdi mdi-eye font-size-16"></i>
                                                                    </a>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>



                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </>)

}
export default CPCBlock;
